/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/marketing/deal-partner.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { ArrowRight, Award, Briefcase, Handshake, Target, TrendingUp, Users } from 'lucide-preact';

/*----------------------------------
- APP
----------------------------------*/

import Motion, { fadeIn } from '@/client/components/Motion';
import PublicFooter from '@/client/components/marketing/PublicFooter';
import PublicHeader from '@/client/components/marketing/PublicHeader';
import Page from '@/client/pages/_layout/_page';
import { MARKETING_URLS } from '@/client/catalogs/marketing/navigation';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/deal-partner', { ...({
  static: {
    refresh: '1h',
    urls: ['/deal-partner']
  }
}), ...{ filepath: "/app/client/pages/marketing/deal-partner.tsx", sourceLocation: { line: 22, column: 1 }, id: "marketing_deal_partner" } }, null, ({}) => <Page withLayout={false}>
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-violet-50">
            <PublicHeader ctaLabel="Become a Partner" ctaHref={MARKETING_URLS.saasDemo} />

            <section className="pt-32 pb-20 px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    <Motion tag="div" initial="hidden" animate="visible" variants={fadeIn} className="text-center">
                        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-violet-500 text-white px-4 py-2 rounded-full mb-6 font-semibold shadow-sm">
                            <Handshake size={18} />
                            Deal Partnership
                        </div>
                        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-orange-600 via-pink-600 to-violet-600 bg-clip-text text-transparent">
                            Partner on Recruitment Mandates
                        </h1>
                        <p className="text-xl text-slate-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                            Collaborate with CrossPath to deliver exceptional recruitment services, leverage our network, and grow your revenue through strategic partnership.
                        </p>
                        <a href={MARKETING_URLS.saasDemo} className="bg-gradient-to-r from-orange-600 to-violet-600 hover:from-orange-700 hover:to-violet-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-105 inline-flex items-center gap-2">
                            Become a Partner
                            <ArrowRight size={20} />
                        </a>
                    </Motion>
                </div>
            </section>

            <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-white to-slate-50">
                <div className="max-w-6xl mx-auto">
                    <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-slate-900 mb-4">Partnership Models</h2>
                        <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                            Choose the collaboration model that best fits your business.
                        </p>
                    </Motion>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[{
            icon: Target,
            title: 'Lead Referral',
            description: 'Introduce companies with recruitment needs and earn referral commissions.',
            commission: 'Aligned on call'
          }, {
            icon: Users,
            title: 'Co-Delivery',
            description: 'Partner on mandates, contribute to sourcing, and share successful outcomes.',
            commission: 'Aligned on call'
          }, {
            icon: Briefcase,
            title: 'White Label',
            description: 'Deliver services under your brand while leveraging our platform.',
            commission: 'Custom'
          }].map((model, index) => <Motion tag="div" key={model.title} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-lg border-2 border-orange-100 hover:border-violet-300 hover:shadow-2xl transition-all">
                                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-violet-500 rounded-2xl flex items-center justify-center mb-6">
                                    <model.icon className="w-8 h-8 text-white" />
                                </div>
                                <h3 className="text-2xl font-bold text-slate-900 mb-3">{model.title}</h3>
                                <p className="text-slate-600 mb-6 leading-relaxed">{model.description}</p>
                                <div className="pt-4 border-t border-slate-200">
                                    <div className="text-sm text-slate-500 mb-1">Commercial Terms</div>
                                    <div className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-violet-600 bg-clip-text text-transparent">
                                        {model.commission}
                                    </div>
                                </div>
                            </Motion>)}
                    </div>
                </div>
            </section>

            <section className="py-20 px-6 lg:px-8">
                <div className="max-w-4xl mx-auto">
                    <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16">
                        <h2 className="text-4xl font-bold bg-gradient-to-r from-orange-600 to-violet-600 bg-clip-text text-transparent mb-4">How Partnership Works</h2>
                        <p className="text-xl text-slate-600">Simple steps to start collaborating.</p>
                    </Motion>

                    <div className="space-y-4">
                        {['Submit your partnership application with details on your network and expertise.', 'Schedule a discovery call to align on the partnership model and expectations.', 'Get onboarded with access to our partner portal and resources.', 'Start referring mandates or co-delivering recruitment projects.', 'Track progress and earn commissions on successful placements.'].map((step, index) => <Motion tag="div" key={index} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 shadow-lg border border-violet-200 flex items-start gap-4">
                                <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-violet-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                                    {index + 1}
                                </div>
                                <p className="text-slate-700 text-lg pt-1">{step}</p>
                            </Motion>)}
                    </div>
                </div>
            </section>

            <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-white">
                <div className="max-w-6xl mx-auto">
                    <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-16">
                        <h2 className="text-4xl font-bold bg-gradient-to-r from-orange-600 to-violet-600 bg-clip-text text-transparent mb-4">Partnership Benefits</h2>
                        <p className="text-xl text-slate-600 max-w-3xl mx-auto">Why leading firms partner with CrossPath.</p>
                    </Motion>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {[{
            icon: Handshake,
            title: 'Co-Sourcing Partnership',
            description: 'Work together on mandates with our team and share successful outcomes.'
          }, {
            icon: TrendingUp,
            title: 'Revenue Share Model',
            description: 'Earn competitive commissions on successful placements.'
          }, {
            icon: Users,
            title: 'Access to Network',
            description: 'Tap into our network of 10,000+ specialized recruiters.'
          }, {
            icon: Award,
            title: 'Quality Assurance',
            description: 'Benefit from a standardized process that protects delivery quality.'
          }].map((benefit, index) => <Motion tag="div" key={benefit.title} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-lg border border-orange-100 hover:border-violet-300 hover:shadow-2xl transition-all">
                                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-violet-500 rounded-xl flex items-center justify-center mb-4">
                                    <benefit.icon className="w-7 h-7 text-white" />
                                </div>
                                <h3 className="text-2xl font-bold text-slate-900 mb-3">{benefit.title}</h3>
                                <p className="text-slate-600 leading-relaxed">{benefit.description}</p>
                            </Motion>)}
                    </div>
                </div>
            </section>

            <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-violet-50 to-orange-50">
                <div className="max-w-5xl mx-auto">
                    <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="text-center mb-12">
                        <h2 className="text-4xl font-bold bg-gradient-to-r from-orange-600 to-violet-600 bg-clip-text text-transparent mb-4">Who This Fits Best</h2>
                        <p className="text-xl text-slate-600">Ideal for partners with strong hiring relationships.</p>
                    </Motion>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {['Executive search firms looking to expand capacity', 'Consulting companies offering recruitment as an adjacent service', 'Industry networks with access to hiring companies', 'Business development professionals in HR and recruitment', 'Professional associations with corporate members', 'Technology partners with complementary solutions'].map(partner => <div key={partner} className="bg-white rounded-xl p-5 border border-orange-100 shadow-sm">
                                <div className="flex items-start gap-3">
                                    <Target className="w-5 h-5 text-violet-600 mt-0.5 flex-shrink-0" />
                                    <span className="text-slate-700">{partner}</span>
                                </div>
                            </div>)}
                    </div>
                </div>
            </section>

            <section className="py-20 px-6 lg:px-8 bg-gradient-to-r from-orange-600 via-pink-600 to-violet-600">
                <div className="max-w-4xl mx-auto text-center">
                    <Motion tag="div" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn}>
                        <h2 className="text-4xl font-bold text-white mb-6">Ready to Partner?</h2>
                        <p className="text-xl text-white/90 mb-8">Apply to become a CrossPath deal partner and co-deliver more mandates.</p>
                        <a href={MARKETING_URLS.saasDemo} className="bg-white text-violet-600 hover:bg-orange-50 px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-105 inline-flex items-center gap-2">
                            Apply for Partnership
                            <ArrowRight size={20} />
                        </a>
                    </Motion>
                </div>
            </section>

            <PublicFooter tagline="Partner with CrossPath to expand recruitment delivery, referral revenue, and white-label capacity." />
        </div>
    </Page>);
};
